module.exports = __webpack_public_path__ + "img/personio.ccf17386.svg";